<list-view *ngIf="listeCompteurDetail" [liste]="listeCompteurDetail"></list-view>